var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageModuleAdminsImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Manage_module_admins",
    "data-name": "Manage module admins",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175.32,
    height: 170.182,
    viewBox: "0 0 175.32 170.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 175.32,
    height: 170.182,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 175.32,
    height: 170.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 48.991,
    height: 27.524,
    fill: "#190e8f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 49.954,
    height: 30.243,
    fill: "#190e8f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 25.957,
    height: 21.745,
    fill: "#190e8f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 29.689,
    height: 8.472,
    fill: "#190e8f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M143.015,1022.9a6.017,6.017,0,0,0-1.768,4.4l1.775,75.078a2.4,2.4,0,0,0,2.39,2.388H274.677a2.4,2.4,0,0,0,2.39-2.388l1.076-74.285a4.163,4.163,0,0,0-4.384-3.685l-126.332-3.269-.156,0a6.029,6.029,0,0,0-4.256,1.759",
    transform: "translate(-141.245 -1021.145)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.005,
    y1: 1.023,
    x2: 0.006,
    y2: 1.023,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M179.59,1067.391a4.229,4.229,0,0,0-1.243,3.1l1.8,71.783a2.268,2.268,0,0,0,2.262,2.262H306.325a2.268,2.268,0,0,0,2.262-2.262l1.015-67.436a5.566,5.566,0,0,0-5.834-5.431l-121.078-3.248-.113,0a4.23,4.23,0,0,0-2.987,1.236",
    transform: "translate(-178.345 -1066.155)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.085,
    y1: 1.315,
    x2: -0.085,
    y2: 1.315,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    d: "M3.263,0H149.135A3.263,3.263,0,0,1,152.4,3.263v0a3.263,3.263,0,0,1-3.263,3.263H3.263A3.263,3.263,0,0,1,0,3.264v0A3.263,3.263,0,0,1,3.263,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.303,
    y1: 0.63,
    x2: -1.302,
    y2: 0.63,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190e8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1908.783,1734.424l44.675,56.532a4.794,4.794,0,0,0,6.758.77l.385-.309a5.156,5.156,0,0,0,.539-7.551l-49.012-52.295Z",
    transform: "translate(-1908.783 -1731.571)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.348,
    y1: 0.896,
    x2: -1.347,
    y2: 0.896,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 66.266,
    height: 65.555,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1066.008,784.925c-15.551-7.874-21.888-26.636-14.156-41.906s26.607-21.265,42.157-13.391,21.888,26.636,14.156,41.906a30.934,30.934,0,0,1-27.721,16.857,31.881,31.881,0,0,1-14.436-3.466m-19-44.361c-9.064,17.9-1.635,39.892,16.594,49.122s40.352,2.2,49.416-15.7,1.635-39.892-16.593-49.122A37.382,37.382,0,0,0,1079.5,720.8,36.257,36.257,0,0,0,1047,740.563",
    transform: "translate(-1043.141 -720.804)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.468,
    y1: 1.287,
    x2: -0.467,
    y2: 1.287,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M471.337,2660.081h11.251a.547.547,0,0,0,.527-.691c-1.282.1-4.006.278-7.737.278a16.033,16.033,0,0,1-5.217-.521,1.207,1.207,0,0,0,1.175.935",
    transform: "translate(-470.162 -2659.146)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.268,
    y1: 3.029,
    x2: -2.264,
    y2: 3.029,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M477.624,2615.8c-3.431.048-4.627.42-7.293.021l-.629,2.085a1.2,1.2,0,0,0-.019.622,16.051,16.051,0,0,0,5.216.521c3.731,0,6.454-.175,7.737-.278a.529.529,0,0,0-.092-.191,6.521,6.521,0,0,0-4.854-2.78h-.066",
    transform: "translate(-469.65 -2615.799)",
    fill: "#09005d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M480.458,2583.069a4.54,4.54,0,0,0,3.215.153l.3-2.275-2.738-.5Z",
    transform: "translate(-480.458 -2580.443)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -8.615,
    y1: 2.285,
    x2: -8.597,
    y2: 2.285,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M797.856,2565.792a16.1,16.1,0,0,1-4.392,2.863,1.206,1.206,0,0,0,1.5-.011l8.77-7.047a.545.545,0,0,0-.02-.866c-.935.883-2.95,2.725-5.858,5.062",
    transform: "translate(-793.464 -2560.73)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -4.727,
    y1: 1.09,
    x2: -4.721,
    y2: 1.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M780.353,2556.656c-2.644,2.186-3.345,3.224-5.672,4.584l.809,2.011a1.188,1.188,0,0,0,.373.494,16.091,16.091,0,0,0,4.392-2.863c2.908-2.336,4.922-4.178,5.858-5.062a.529.529,0,0,0-.191-.091,9.027,9.027,0,0,0-2.007-.239,5.48,5.48,0,0,0-3.561,1.165",
    transform: "translate(-774.681 -2555.491)",
    fill: "#09005d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M172.065,2109.371l20.616,3.372c1.806,4.124-.621,23.141-.621,23.141,2.366.736,3.429.224,3.429.224s7.093-25.771,3.188-27.609-22.946-3.394-22.946-3.394Z",
    transform: "translate(-172.065 -2105.105)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M744.621,2572.586c.177.161,1.892,3.62,1.892,3.62s1.909-.413,2.3-1.621l-1.718-3.122Z",
    transform: "translate(-744.621 -2571.463)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -11.183,
    y1: 1.76,
    x2: -11.168,
    y2: 1.76,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M38.623,2106.054a5.22,5.22,0,0,0,4.982,5.107l22.509,1.026a1.08,1.08,0,0,1,1,.811c.529,2.046,3.114,8.329,15.752,20.866a1.019,1.019,0,0,0,1.26.137l1.8-1.136a.414.414,0,0,0,.136-.56l-13.106-22.38a5.074,5.074,0,0,0-3.082-2.286l-19.184-4.9-11.468-.159a9.645,9.645,0,0,0-.6,3.477",
    transform: "translate(-38.622 -2102.577)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M323.178,1553.417l5.081,2.835s1.145-4.513,3.761-5.835l-3.973-3.329a28.329,28.329,0,0,1-4.87,6.328",
    transform: "translate(-323.178 -1547.088)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1.602,
    y1: 6.384,
    x2: -1.597,
    y2: 6.384,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M59.718,1636.411c-2.638,1.608-15.05,10.109-18.124,29.388a27.852,27.852,0,0,0,11.877,0s8.116-10.91,11.256-13.88a22.332,22.332,0,0,0,16.156,9.023l.622-1.389s-8.875-4.091-11.607-10.377-3.83-8.967-6.315-10.607c-1.548-1.021-2.475-1.719-2.954-2.1a.8.8,0,0,0-.91-.058",
    transform: "translate(-41.594 -1636.295)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M359.206,1796.661l-3-5.324a24.091,24.091,0,0,0,3,5.324",
    transform: "translate(-356.203 -1791.337)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -7.465,
    y1: 10.79,
    x2: -7.444,
    y2: 10.79,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M660.287,1974.325l-3.81.882-1.255.334.633,1.055,9.046.015-3.276-2.061a1.768,1.768,0,0,0-1.339-.226",
    transform: "translate(-655.222 -1974.279)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -4.26,
    y1: 19.694,
    x2: -4.254,
    y2: 19.694,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M352.994,1449.1c-.223,1.416,2.009,4.509,2.009,4.509a5.377,5.377,0,0,0,6.157,2.214c2.45-.767,1.8-2.113,1.391-4.266s-2.75-6.048-2.75-6.048-6.584,2.175-6.807,3.592",
    transform: "translate(-352.979 -1445.509)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1.269,
    y1: 5.253,
    x2: -1.265,
    y2: 5.253,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M311.007,1372.417l-.078.212a.172.172,0,0,1-.318.009.171.171,0,0,0-.311-.006c-.237.522-.946,1.414-3.074,2.1-3.019.979-4.9,2.5-4.668,4.646a.172.172,0,0,1-.245.174c-.247-.109-.621-.126-1.055.349-.756.826-.164,2.634,1.9,3.913a.171.171,0,0,1,.028.274c-.309.264-.743.854.653,1.379a3.507,3.507,0,0,0,2.5.24.172.172,0,0,0,.106-.193l-.367-1.88a.172.172,0,0,1,.146-.2l.676-.089.317-.042s-1.659-2.507-.574-3.129,5.51-2.148,6.279-3.891a3.026,3.026,0,0,0-1.7-3.973.154.154,0,0,0-.045-.007.174.174,0,0,0-.16.114",
    transform: "translate(-300.94 -1372.303)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.82,
    y1: 4.553,
    x2: -0.817,
    y2: 4.553,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M359.358,1524.778c-1.086.9,1,2.877,1.968,2.85l.152-1.2s-.748-1.844-1.64-1.844a.744.744,0,0,0-.48.191",
    transform: "translate(-359.053 -1524.587)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -4.779,
    y1: 16.888,
    x2: -4.765,
    y2: 16.888,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M606.823,2011.8l-19.326.019a.863.863,0,0,0-.042,1.726h.044l19.326-.019a.864.864,0,0,0,.013-1.727h-.015",
    transform: "translate(-586.633 -2011.804)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -1.581,
    y1: 2.379,
    x2: -1.578,
    y2: 2.379,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M903.827,1731.931l-.02.04-8.131,17.532a.863.863,0,1,0,1.567.726l8.132-17.532a.863.863,0,0,0-1.547-.766",
    transform: "translate(-895.595 -1731.469)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -2.342,
    y1: 2.529,
    x2: -2.339,
    y2: 2.529,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(117.536 0)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1868.186,27.51a.718.718,0,0,1-.594-.756c.054-.81.144-1.629.268-2.435a.719.719,0,0,1,.819-.6l.013,0a.718.718,0,0,1,.587.817c-.117.766-.2,1.544-.254,2.313a.718.718,0,0,1-.765.669.69.69,0,0,1-.075-.009m1.112-6.159a.719.719,0,0,1-.567-.913c.232-.781.5-1.56.8-2.315a.718.718,0,1,1,1.337.524c-.281.718-.536,1.458-.757,2.2a.718.718,0,0,1-.81.5m2.44-5.761a.719.719,0,0,1-.5-1.061c.4-.708.835-1.408,1.294-2.08a.718.718,0,1,1,1.186.811c-.436.638-.849,1.3-1.228,1.975a.719.719,0,0,1-.748.355m3.668-5.072A.719.719,0,0,1,1875,9.327c.548-.6,1.129-1.187,1.726-1.739a.718.718,0,0,1,.976,1.055c-.567.524-1.119,1.08-1.64,1.652a.718.718,0,0,1-.654.224m4.707-4.126a.718.718,0,0,1-.288-1.3c.666-.464,1.362-.906,2.067-1.313a.718.718,0,1,1,.719,1.244c-.671.387-1.332.807-1.965,1.248a.717.717,0,0,1-.533.118m5.5-2.982a.718.718,0,0,1-.148-1.374c.754-.305,1.53-.582,2.307-.823a.718.718,0,0,1,.425,1.373c-.738.229-1.476.492-2.192.782a.715.715,0,0,1-.392.042m26.23,2.8a.713.713,0,0,1-.281-.114c-.638-.434-1.3-.847-1.978-1.225a.718.718,0,1,1,.7-1.253c.71.4,1.411.833,2.083,1.29a.719.719,0,0,1-.527,1.3m-20.208-4.487a.718.718,0,0,1,.007-1.417c.8-.13,1.621-.227,2.432-.288a.718.718,0,1,1,.108,1.433c-.77.058-1.547.15-2.309.274a.72.72,0,0,1-.237,0m14.671,1.571a.724.724,0,0,1-.139-.039c-.719-.281-1.46-.534-2.2-.753a.718.718,0,0,1,.407-1.378c.781.231,1.561.5,2.318.792a.718.718,0,0,1-.383,1.377m-8.423-1.871a.718.718,0,0,1,.17-1.425c.811.053,1.63.141,2.435.263l.015,0a.718.718,0,0,1-.23,1.418c-.765-.116-1.543-.2-2.313-.25-.026,0-.052,0-.077-.009",
    transform: "translate(-1867.591 0.004)",
    fill: "#190e8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M2611.378,116.629a.715.715,0,0,1-.382-.2c-.263-.26-.537-.519-.812-.77a.718.718,0,1,1,.967-1.063c.29.264.577.536.855.81a.718.718,0,0,1-.627,1.219",
    transform: "translate(-2563.229 -107.212)",
    fill: "#190e8f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(124.917 27.092)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M2756.212,433.053a.719.719,0,0,1-.6-.717c0-.37,0-.747-.009-1.119a.719.719,0,0,1,1.437-.042c.011.392.015.789.009,1.179a.718.718,0,0,1-.727.709.728.728,0,0,1-.115-.011",
    transform: "translate(-2707.102 -430.478)",
    fill: "#190e8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M2056.236,534.068q-.489-.084-.978-.186a.718.718,0,1,1,.292-1.407c.753.156,1.51.282,2.26.374a.718.718,0,0,1-.175,1.426c-.464-.057-.935-.127-1.4-.207m-4.63-1.209a.708.708,0,0,1-.119-.031c-.755-.268-1.508-.57-2.237-.9a.718.718,0,0,1,.592-1.309c.692.313,1.407.6,2.125.855a.718.718,0,0,1-.361,1.385m9.8,1.616a.718.718,0,0,1,.113-1.426c.759-.011,1.527-.055,2.285-.131a.718.718,0,1,1,.143,1.43c-.8.08-1.607.126-2.407.138a.724.724,0,0,1-.134-.01m-15.349-4.3a.718.718,0,0,1-.26-.1c-.677-.427-1.345-.887-1.984-1.37a.718.718,0,0,1,.865-1.147c.607.458,1.24.9,1.884,1.3a.719.719,0,0,1-.506,1.316m21.454,3.527a.718.718,0,0,1-.046-1.406c.737-.178,1.477-.39,2.2-.63a.718.718,0,1,1,.453,1.363c-.761.253-1.54.476-2.316.663a.718.718,0,0,1-.291.01m5.789-2.094a.718.718,0,0,1-.2-1.352c.683-.336,1.359-.7,2.011-1.1a.718.718,0,1,1,.739,1.232c-.685.411-1.4.8-2.116,1.153a.715.715,0,0,1-.439.063m5.195-3.306a.718.718,0,0,1-.327-1.268c.594-.477,1.174-.984,1.724-1.507a.718.718,0,0,1,.99,1.041c-.579.551-1.189,1.084-1.814,1.586a.717.717,0,0,1-.572.148m4.35-4.36a.718.718,0,0,1-.438-1.156c.475-.595.93-1.216,1.352-1.848a.718.718,0,1,1,1.194.8c-.444.665-.923,1.32-1.423,1.946a.719.719,0,0,1-.685.26m3.288-5.21a.737.737,0,0,1-.192-.062.719.719,0,0,1-.333-.96c.332-.683.638-1.389.911-2.1a.718.718,0,0,1,1.341.516c-.288.748-.61,1.491-.959,2.21a.719.719,0,0,1-.769.395m2.061-5.8-.043-.009a.718.718,0,0,1-.534-.864c.129-.545.242-1.1.338-1.651q.051-.3.1-.6a.718.718,0,0,1,.817-.6.711.711,0,0,1,.6.817q-.047.314-.1.629c-.1.579-.22,1.164-.355,1.737a.718.718,0,0,1-.821.543",
    transform: "translate(-2039.84 -504.242)",
    fill: "#190e8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1986.269,747.783a.718.718,0,0,1-.385-.2c-.275-.274-.55-.56-.817-.849a.718.718,0,1,1,1.055-.975c.253.274.514.545.776.806a.718.718,0,0,1-.63,1.216",
    transform: "translate(-1984.877 -725.702)",
    fill: "#190e8f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1987.317,145.724a.336.336,0,0,0,.353.165l4.019-.737a17.8,17.8,0,0,0,4.538,3.56l.245,4.076a.335.335,0,0,0,.245.3l4.721,1.318a.336.336,0,0,0,.366-.133l2.32-3.361a17.8,17.8,0,0,0,5.725-.7l3.057,2.711a.336.336,0,0,0,.387.041l4.27-2.407a.335.335,0,0,0,.165-.353l-.736-4.019a17.8,17.8,0,0,0,3.56-4.538l4.077-.245a.336.336,0,0,0,.3-.245l1.317-4.721a.336.336,0,0,0-.133-.366l-3.361-2.32a17.8,17.8,0,0,0-.7-5.725l2.711-3.057a.336.336,0,0,0,.041-.388l-2.407-4.27a.335.335,0,0,0-.353-.165l-4.019.736a17.8,17.8,0,0,0-4.538-3.56l-.245-4.076a.336.336,0,0,0-.245-.3l-4.721-1.317a.336.336,0,0,0-.366.133l-2.32,3.361a17.8,17.8,0,0,0-5.725.7l-3.057-2.711a.336.336,0,0,0-.388-.041l-4.27,2.407a.336.336,0,0,0-.166.353l.737,4.019a17.8,17.8,0,0,0-3.56,4.538l-4.076.245a.336.336,0,0,0-.3.245l-1.317,4.721a.336.336,0,0,0,.133.367l3.361,2.32a17.8,17.8,0,0,0,.7,5.725l-2.711,3.057a.335.335,0,0,0-.041.388Z",
    transform: "translate(-1858.633 -104.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M2249.3,383.16a4.93,4.93,0,1,1,.72.071,4.934,4.934,0,0,1-.72-.071m1.494-8.576a3.838,3.838,0,0,0-.558-.055,3.764,3.764,0,1,0,.558.055",
    transform: "translate(-2103.915 -349.88)",
    fill: "#190e8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M2142.428,282.278a12.336,12.336,0,0,1-1.215-.274c-.127-.035-.253-.073-.379-.112a12.211,12.211,0,0,1-1.8-.726l-.023-.012-.067-.034-.129-.067a.287.287,0,1,1,.268-.508,11.552,11.552,0,0,0,13.1-1.633,11.467,11.467,0,0,0,3.4-5.474,11.673,11.673,0,0,0,.261-1.159,11.541,11.541,0,1,0-22.51,1.1.282.282,0,0,1,.006.125.287.287,0,0,1-.56.027,12.116,12.116,0,1,1,23.63-1.157q-.106.61-.274,1.216a12.116,12.116,0,0,1-13.71,8.686",
    transform: "translate(-1998.155 -241.968)",
    fill: "#190e8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(90.289 20.253)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1435.109,637.658a.444.444,0,0,1-.365-.387c-.043-.374-.075-.755-.1-1.131a.444.444,0,1,1,.886-.048c.02.359.05.722.091,1.078a.443.443,0,0,1-.517.488",
    transform: "translate(-1434.648 -615.919)",
    fill: "#190e8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1435.289,340.137a.444.444,0,0,1-.367-.468,19.2,19.2,0,0,1,.235-1.938q.035-.2.074-.4a.459.459,0,0,1,.52-.351.444.444,0,0,1,.351.52c-.025.129-.049.258-.071.386a18.466,18.466,0,0,0-.224,1.848.444.444,0,0,1-.473.412l-.045-.006m.88-4.522a.455.455,0,0,1-.062-.015.444.444,0,0,1-.285-.559,19.254,19.254,0,0,1,.866-2.2.444.444,0,0,1,.8.376,18.354,18.354,0,0,0-.826,2.1.444.444,0,0,1-.5.3m1.951-4.173a.444.444,0,0,1-.3-.674,19.138,19.138,0,0,1,1.38-1.918.444.444,0,0,1,.687.562,18.294,18.294,0,0,0-1.316,1.829.444.444,0,0,1-.451.2m2.917-3.566a.444.444,0,0,1-.23-.758,19.24,19.24,0,0,1,1.807-1.522.444.444,0,1,1,.528.713,18.311,18.311,0,0,0-1.723,1.451.443.443,0,0,1-.382.116m3.7-2.745a.444.444,0,0,1-.143-.823,19.4,19.4,0,0,1,2.121-1.036.444.444,0,1,1,.34.819,18.494,18.494,0,0,0-2.024.989.442.442,0,0,1-.294.051m4.253-1.764a.444.444,0,0,1-.043-.865,19.129,19.129,0,0,1,2.31-.488.444.444,0,0,1,.129.878,18.183,18.183,0,0,0-2.2.465.443.443,0,0,1-.194.01m4.555-.67a.444.444,0,0,1,.066-.881,19.222,19.222,0,0,1,2.36.094.444.444,0,0,1-.09.883,18.234,18.234,0,0,0-2.251-.09.44.44,0,0,1-.086-.006m6.8,1.118a.422.422,0,0,1-.076-.02,18.413,18.413,0,0,0-1.876-.566q-.144-.036-.286-.068a.444.444,0,0,1,.2-.866c.1.023.2.047.3.072a19.3,19.3,0,0,1,1.964.593.444.444,0,0,1-.226.854",
    transform: "translate(-1434.904 -321.811)",
    fill: "#190e8f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(95.242 50.103)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1562.067,804.349a.444.444,0,0,1,.146-.875,18.375,18.375,0,0,0,2.2.216.444.444,0,1,1-.033.887,19.331,19.331,0,0,1-2.311-.227h-.006m-2.216-.492-.047-.011a19.385,19.385,0,0,1-2.192-.771.444.444,0,0,1,.344-.818,18.574,18.574,0,0,0,2.092.736.444.444,0,0,1-.2.864m6.743.659a.444.444,0,0,1,.038-.879,18.431,18.431,0,0,0,2.192-.324.444.444,0,0,1,.182.869,19.26,19.26,0,0,1-2.3.339.447.447,0,0,1-.114,0m-10.92-2.42a.444.444,0,0,1-.145-.052,19.077,19.077,0,0,1-1.942-1.278.444.444,0,0,1,.532-.71,18.206,18.206,0,0,0,1.851,1.218.444.444,0,0,1-.3.822m15.353,1.487a.444.444,0,0,1-.068-.857,18.242,18.242,0,0,0,2.05-.841.444.444,0,1,1,.386.8,19.325,19.325,0,0,1-2.149.882.442.442,0,0,1-.218.017m4.08-1.969a.444.444,0,0,1-.164-.811,18.548,18.548,0,0,0,1.79-1.307.444.444,0,0,1,.566.683,19.4,19.4,0,0,1-1.876,1.37.443.443,0,0,1-.315.064m3.491-2.89a.444.444,0,0,1-.246-.743,18.2,18.2,0,0,0,1.424-1.7.444.444,0,0,1,.714.528,19.215,19.215,0,0,1-1.494,1.781.444.444,0,0,1-.4.132",
    transform: "translate(-1550.888 -796.106)",
    fill: "#190e8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1514.489,823a.441.441,0,0,1-.231-.117c-.274-.263-.541-.536-.794-.81a.444.444,0,1,1,.652-.6c.242.262.5.522.758.773a.444.444,0,0,1-.384.757",
    transform: "translate(-1513.346 -819.742)",
    fill: "#190e8f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1514.391,419.368a.225.225,0,0,0,.236.111l2.69-.493a11.91,11.91,0,0,0,3.036,2.382l.164,2.728a.224.224,0,0,0,.164.2l3.159.882a.225.225,0,0,0,.245-.089l1.552-2.249a11.91,11.91,0,0,0,3.831-.466l2.046,1.814a.225.225,0,0,0,.26.028l2.857-1.61a.225.225,0,0,0,.111-.236l-.493-2.69a11.909,11.909,0,0,0,2.382-3.036l2.728-.164a.225.225,0,0,0,.2-.164l.881-3.159a.224.224,0,0,0-.089-.245l-2.249-1.552a11.9,11.9,0,0,0-.465-3.831l1.814-2.046a.225.225,0,0,0,.027-.259l-1.61-2.857a.224.224,0,0,0-.236-.111l-2.69.493a11.911,11.911,0,0,0-3.036-2.382l-.164-2.728a.225.225,0,0,0-.164-.2l-3.159-.882a.224.224,0,0,0-.245.089l-1.552,2.249a11.909,11.909,0,0,0-3.831.465l-2.046-1.814a.224.224,0,0,0-.259-.028l-2.857,1.61a.225.225,0,0,0-.111.236l.493,2.69a11.91,11.91,0,0,0-2.382,3.036l-2.728.164a.224.224,0,0,0-.2.164l-.882,3.159a.225.225,0,0,0,.089.245l2.249,1.552a11.906,11.906,0,0,0,.465,3.831l-1.814,2.046a.225.225,0,0,0-.028.259Z",
    transform: "translate(-1416.667 -371.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1688.805,577.424a3.364,3.364,0,1,1,.5.049,3.431,3.431,0,0,1-.5-.049m1-5.739a2.518,2.518,0,0,0-.361-.036,2.468,2.468,0,1,0,.361.036",
    transform: "translate(-1579.919 -534.841)",
    fill: "#190e8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1614.389,507.192q-.415-.072-.829-.187a8.392,8.392,0,0,1-1.586-.621l-.068-.035a.444.444,0,0,1-.231-.468.455.455,0,0,1,.045-.132.444.444,0,0,1,.6-.186,7.5,7.5,0,0,0,1.479.587h0l.084.023a7.4,7.4,0,0,0,3.658.052,7.511,7.511,0,0,0,1.875-.729l.015-.008.044-.025a7.423,7.423,0,0,0,3.527-4.5,7.615,7.615,0,0,0,.169-.75,7.471,7.471,0,1,0-14.572.713.444.444,0,0,1-.31.545.444.444,0,0,1-.545-.311,8.359,8.359,0,1,1,16.3-.8,8.508,8.508,0,0,1-.189.839,8.371,8.371,0,0,1-9.468,5.991",
    transform: "translate(-1506.284 -459.717)",
    fill: "#1a0f91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(8.889 64.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 156.354,
    height: 122.64,
    transform: "translate(-25.126 8.363) rotate(-18.435)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(11.224 67.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 131.284,
    height: 78.378,
    transform: "translate(-0.028 0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M2221.612,1675.263h-.005a.331.331,0,0,1-.326-.336l.08-5.469a.331.331,0,0,1,.331-.326h0a.332.332,0,0,1,.328.336l-.08,5.469a.332.332,0,0,1-.331.326",
    transform: "translate(-2081.485 -1564.085)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1577.053,1148.916h0a.332.332,0,0,1-.327-.337l.308-20.946a3.933,3.933,0,0,0-1.123-2.946,5.536,5.536,0,0,0-3.663-1.25l-38.7-1.038a.331.331,0,0,1-.323-.34.318.318,0,0,1,.34-.322l38.676,1.038a6.085,6.085,0,0,1,4.126,1.434,4.576,4.576,0,0,1,1.327,3.428l-.308,20.953a.332.332,0,0,1-.331.327",
    transform: "translate(-1436.73 -1051.14)",
    fill: "#7d97f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(0.179 147.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 42.362,
    height: 149.623,
    transform: "translate(-1.499 6.162) rotate(-76.329)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 40.015,
    height: 2.741,
    transform: "translate(23.269 90.369)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 40.015,
    height: 2.741,
    transform: "translate(23.08 72.05)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.362 76.74)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 4.153,
    height: 2.741,
    transform: "translate(28.255 76.521)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.333 81.322)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 4.153,
    height: 2.741,
    transform: "translate(28.234 81.102)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.227 85.896)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 4.153,
    height: 2.741,
    transform: "translate(27.987 85.676)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 40.015,
    height: 2.741,
    transform: "translate(23.079 109.442)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.172 95.813)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 4.153,
    height: 2.741,
    transform: "translate(28.065 95.593)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.143 100.394)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 4.153,
    height: 2.741,
    transform: "translate(28.044 100.175)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.037 104.968)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 4.153,
    height: 2.741,
    transform: "translate(27.797 104.749)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 40.015,
    height: 2.741,
    transform: "translate(23.079 128.49)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.172 114.861)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 4.153,
    height: 2.741,
    transform: "translate(28.065 114.641)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.143 119.442)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 4.153,
    height: 2.741,
    transform: "translate(28.044 119.223)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.037 124.016)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 4.153,
    height: 2.741,
    transform: "translate(27.797 123.797)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.362 133.459)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 4.153,
    height: 2.741,
    transform: "translate(28.255 133.239)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 28.854,
    height: 2.741,
    transform: "translate(34.134 138.04)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 4.153,
    height: 2.741,
    transform: "translate(28.034 137.821)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 28.803,
    height: 2.778,
    transform: "translate(93.692 124.486)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 46.731,
    height: 2.778,
    transform: "translate(81.975 119.844)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 37.459,
    height: 2.778,
    transform: "translate(96.92 115.206)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 21.36,
    height: 2.778,
    transform: "translate(96.92 110.565)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 37.413,
    height: 2.778,
    transform: "translate(97.417 105.918)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 31.614,
    height: 2.778,
    transform: "translate(94.068 101.28)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 33.754,
    height: 2.778,
    transform: "translate(81.976 96.631)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 38.511,
    height: 2.778,
    transform: "translate(97.044 91.991)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 38.988,
    height: 2.778,
    transform: "translate(97.044 87.349)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 38.409,
    height: 2.778,
    transform: "translate(97.417 82.707)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 31.465,
    height: 2.778,
    transform: "translate(90.464 78.064)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 91.874)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 96.649)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 101.229)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 105.888)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 110.662)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 115.242)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 8.159,
    height: 2.778,
    transform: "translate(71.135 119.807)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 8.159,
    height: 2.778,
    transform: "translate(71.135 124.582)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 8.159,
    height: 2.778,
    transform: "translate(71.135 129.162)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 8.159,
    height: 2.778,
    transform: "translate(71.135 133.834)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 8.159,
    height: 2.778,
    transform: "translate(71.135 138.609)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 87.348)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 82.709)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 78.064)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 8.159,
    height: 2.778,
    transform: "translate(70.722 73.422)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1302.585,1166.628v2.778h39.127a2.8,2.8,0,0,0-2.815-2.778Z",
    transform: "translate(-1220.608 -1093.207)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 39.456,
    height: 2.778,
    transform: "translate(97.293 138.791)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 38.739,
    height: 2.778,
    transform: "translate(97.293 134.008)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1545.937,2056.735v2.778h24.636c0-1.534-.793-2.778-1.773-2.778Z",
    transform: "translate(-1448.644 -1927.295)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1058.678,1208.3h.045a.377.377,0,0,0,.377-.376v-71.164a.377.377,0,0,0-.377-.376h-.045a.376.376,0,0,0-.377.376v71.164a.376.376,0,0,0,.377.376",
    transform: "translate(-991.697 -1064.861)",
    fill: "#7d97f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(120.128 108.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 79.732,
    height: 76.472,
    transform: "translate(-24.916 49.198) rotate(-63.14)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(69.385 49.059)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1105.962,797.273c-8.146,16.086-1.469,35.851,14.912,44.146s36.264,1.98,44.41-14.106,1.469-35.85-14.912-44.146-36.264-1.979-44.41,14.106",
    transform: "translate(-1102.49 -779.516)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(65.649 45.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 105.955,
    height: 108.942,
    transform: "translate(-34.66 64.698) rotate(-65.519)",
    fill: "url(#linear-gradient-5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1602.307,812.518a.094.094,0,0,1-.025-.132c.481-.711.942-1.45,1.368-2.2a.095.095,0,0,1,.165.094c-.429.752-.891,1.5-1.376,2.21a.1.1,0,0,1-.091.041.092.092,0,0,1-.041-.016m4.389-9.165a.1.1,0,0,1-.064-.118,33.119,33.119,0,0,0,1.292-6.923,33.835,33.835,0,0,0-4.235-19.159,34.909,34.909,0,0,0-33.5-17.677.095.095,0,1,1-.017-.189,35.1,35.1,0,0,1,33.688,17.773,34.026,34.026,0,0,1,4.259,19.266,33.3,33.3,0,0,1-1.3,6.963.1.1,0,0,1-.1.067l-.015,0",
    transform: "translate(-1471.268 -711.368)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M2628.546,2488.869c2.11.273,3.572-.286,4.345-1.663a3.852,3.852,0,0,0-.567-4.447l-5.79-6.466a.095.095,0,1,0-.142.126l5.79,6.467a3.664,3.664,0,0,1,.543,4.227c-.74,1.316-2.153,1.843-4.221,1.559h0a.095.095,0,0,0-.025.188l.067.009",
    transform: "translate(-2461.08 -2320.419)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M2586.932,2432.309a.095.095,0,0,0,.083-.157l-.75-.838a.095.095,0,1,0-.141.127l.75.838a.1.1,0,0,0,.058.031",
    transform: "translate(-2423.344 -2278.27)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M91.75,195.144a.37.37,0,0,1-.359-.365c-.037-2.042-.666-12.184-9.488-14.3-9.821-2.359-14.316,7.752-14.316,7.752s-12.152-4.719-14.482,7.921C45.486,198,43.507,208.075,48.462,213a4.233,4.233,0,0,0,2.946,1.234l47.717.435a3.147,3.147,0,0,0,3.04-2.275c1.491-5.093,3.444-16.92-10.416-17.248",
    transform: "translate(-44.063 -149.491)",
    fill: "#e1e1e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M118.213,219.273a.37.37,0,0,1-.358-.364c-.039-1.959-.662-11.363-8.971-13.334-9.287-2.2-13.537,7.24-13.537,7.24s-11.49-4.407-13.694,7.4c-7.136,1.712-9.04,10.957-4.524,15.6a4.236,4.236,0,0,0,3,1.287l44.919.4a3.147,3.147,0,0,0,3.042-2.283c1.4-4.837,3.063-15.633-9.877-15.947",
    transform: "translate(-71.617 -173.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M6.511,2277.09c-.532.788-2.649,18.626-2.98,25.214a.781.781,0,0,0,1.551.157l3.871-24.8Z",
    transform: "translate(-3.308 -2133.782)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M284.865,2277.09c.532.788,2.648,18.626,2.98,25.214a.781.781,0,0,1-1.551.157l-3.871-24.8Z",
    transform: "translate(-264.649 -2133.782)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M0,2217.293l0,.194a2.651,2.651,0,0,0,2.7,2.573l17.89.3a2.675,2.675,0,0,0,2.8-2.427l.009-.178a2.641,2.641,0,0,0-2.7-2.675l-17.9-.321A2.665,2.665,0,0,0,0,2217.293",
    transform: "translate(0 -2075.378)",
    fill: "#7d97f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(29.589 167.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 13.044,
    height: 0.935,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(29.557 164.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 5.078,
    height: 13.331,
    transform: "matrix(0.143, -0.99, 0.99, 0.143, -0.475, 3.183)",
    fill: "#09005d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(30.237 162.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 3.51,
    height: 3.404,
    transform: "translate(0)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(49.936 161.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 10.564,
    height: 8.282,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(48.754 160.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 9.807,
    height: 12.496,
    transform: "translate(-1.17 8.085) rotate(-81.764)",
    fill: "#09005d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(10.829 132.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 43.753,
    height: 43.833,
    transform: "translate(-15.656 13.973) rotate(-41.75)",
    fill: "#090067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(46.862 161.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 4.19,
    height: 4.743,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(2.431 132.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M0,0H53.044V57.149H0Z",
    transform: "matrix(0.566, -0.824, 0.824, 0.566, -14.807, 21.526)",
    fill: "#090067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(20.339 97.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 11.778,
    height: 11.598,
    transform: "translate(-3.14 7.919) rotate(-68.369)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(2.618 102.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 33.815,
    height: 42.065,
    transform: "matrix(0.073, -0.997, 0.997, 0.073, -2.255, 30.82)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(22.417 112.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 3.003,
    height: 5.324,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(41.236 124.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 9.679,
    height: 2.332,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(22.215 90.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 15.5,
    height: 15.5,
    transform: "matrix(0.708, -0.706, 0.706, 0.708, -5.748, 5.526)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(18.939 86.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 18.995,
    height: 18.99,
    transform: "matrix(0.703, -0.711, 0.711, 0.703, -7.292, 6.934)",
    fill: "url(#linear-gradient-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(22.597 95.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 4.436,
    height: 4.436,
    transform: "translate(-2.315 1.53) rotate(-44.926)",
    fill: "url(#linear-gradient-15)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(36.919 126.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M572.752,1856.479l10.717,11.417,12.086-11.3-10.717-11.417Z",
    transform: "translate(-573.626 -1855.661)",
    fill: "url(#linear-gradient-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(56.364 108.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M817.441,1683.708l-14.847,4.9,6.717,20.5,14.847-4.9Z",
    transform: "translate(-808.447 -1686.714)",
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M583.938,2062.615c-.085.35-8.148,30.593-10.193,38.26a1.375,1.375,0,1,0,2.66.7l8.951-36.293Z",
    transform: "translate(-537.592 -1932.805)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M785.465,2062.615c.084.35,8.148,30.593,10.193,38.26a1.375,1.375,0,1,1-2.66.7l-8.951-36.293Z",
    transform: "translate(-734.703 -1932.805)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M737.145,2046.9h-5.022v4.033a1.043,1.043,0,0,0,1.037,1.049h.689v9.059a.785.785,0,1,0,1.57,0v-9.059h.35a1.385,1.385,0,0,0,1.376-1.393Z",
    transform: "translate(-686.047 -1918.081)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M518.036,2031.508h28.042a.861.861,0,0,1,.832.653l.392,1.535a.867.867,0,0,1-.837,1.087l-28.775-.167a.868.868,0,0,1-.828-1.082l.341-1.368a.862.862,0,0,1,.833-.657",
    transform: "translate(-484.309 -1903.656)",
    fill: "#bdd0fb"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageModuleAdminsImg);
export default __webpack_public_path__ + "static/media/manage_module_admins_img.f7c61f58faa7d0e37909ba88ff80e75a.svg";
export { ForwardRef as ReactComponent };